import { platformChannelLabels, type GenerationChannel } from "./components/growth-content-channels";

export const contentPlatforms = [
  { value: "xiaohongshu", key: "contentXiaohongshu", label: "小红书图文", hash: "#/marketing/content/xiaohongshu", short: "红", color: "#b3485e", description: "生活场景 · 图文笔记", guide: "把真实服务写成有用的生活经验，分享给本地家庭。", format: "图文笔记", video: false },
  { value: "douyin", key: "contentDouyin", label: "抖音短视频", hash: "#/marketing/content/douyin", short: "抖", color: "#313b45", description: "快速触达 · 短视频", guide: "上传拍摄好的视频，核对作品文案和位置后发布。", format: "短视频脚本", video: true },
  { value: "wechat_channels", key: "contentWechatChannels", label: "微信视频号", hash: "#/marketing/content/wechat_channels", short: "视", color: "#946d37", description: "熟人传播 · 生活视频", guide: "用真实的服务场景，和本地家庭建立更多连接。", format: "短视频脚本", video: true },
  { value: "wechat_official", key: "contentWechatOfficial", label: "微信公众号", hash: "#/marketing/content/wechat_official", short: "公", color: "#357757", description: "知识服务 · 深度长文", guide: "准备一篇排版清晰的文章，通过微信官方接口发布。", format: "公众号文章", video: false }
] as const;

export type ContentPlatform = typeof contentPlatforms[number]["value"];
export type ContentPlatformDefinition = typeof contentPlatforms[number];
export const contentPlatformActionColors: Record<ContentPlatform, string> = {
  xiaohongshu: "#b72f4a", wechat_official: "#157e4e", douyin: "#222936", wechat_channels: "#925c0e"
};
const matchesPlatform = (value: unknown, platform: ContentPlatform) =>
  platformChannelLabels[platform].includes(String(value ?? "").trim().toLowerCase());

export function contentsForPlatform<T extends { platform?: string; channel_id?: string }>(
  contents: T[], channels: Pick<GenerationChannel, "id" | "platform">[], platform?: ContentPlatform
): T[] {
  if (!platform) return contents;
  const byId = new Map(channels.map(channel => [channel.id, channel.platform]));
  return contents.filter(content => matchesPlatform(content.platform || byId.get(content.channel_id || ""), platform));
}

export function batchesForPlatform<T extends { platforms?: unknown; platforms_json?: string }>(batches: T[], platform?: ContentPlatform): T[] {
  if (!platform) return batches;
  return batches.filter(batch => {
    let platforms = batch.platforms;
    if (!Array.isArray(platforms)) {
      try { platforms = JSON.parse(batch.platforms_json || "[]"); } catch { return false; }
    }
    return Array.isArray(platforms) && platforms.some(value => matchesPlatform(value, platform));
  });
}

export function variantsForPlatform<T extends { platform?: string }>(variants: T[], platform?: ContentPlatform): T[] {
  return platform ? variants.filter(variant => matchesPlatform(variant.platform, platform)) : variants;
}
